import { ChevronRightIc, Image } from "@/components/Elements";
import { NotificationCategory } from "@/features/misc/types/notification";
import { RouteConstant } from "@/routes/routeConstant";
import { useGetNotificationCountMutation } from "@/services/modules/chat";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const RecipientHeader = () => {
  const [getNotificationCount, data] = useGetNotificationCountMutation();
  const notificationCount = data.data;
  const navigate = useNavigate();

  useEffect(() => {
    getNotificationCount(NotificationCategory.Chat);
  }, []);

  const handleNotification = () => {
    navigate(`${RouteConstant.Notification}/${NotificationCategory.Chat}`);
  };

  const handleBack = () => {
    navigate(RouteConstant.Posts);
  };

  return (
    <div className="flex justify-between items-center">
      <div onClick={handleNotification} className="relative">
        <Image src="bell.png" className="w-[22px] h-[22px]" />
        {notificationCount != undefined && notificationCount > 0 && (
          <div className="w-[18px] h-[18px] bg-[#e8434d] rounded-[7px] flex items-center justify-center absolute top-[-16px] right-[-6px]">
            <div className="text-[#fff] text-[11px]">{notificationCount}</div>
          </div>
        )}
      </div>
    </div>
  );
};
